module.exports = __webpack_public_path__ + "img/Apple-badge.7ede6369.png";